/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type OfferList_offers$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type OffersContainer_lists$ref: FragmentReference;
declare export opaque type OffersContainer_lists$fragmentType: OffersContainer_lists$ref;
export type OffersContainer_lists = {|
  +offers: {|
    +pageInfo: {|
      +hasNextPage: boolean,
      +endCursor: ?string,
    |},
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +$fragmentRefs: OfferList_offers$ref,
      |}
    |}>,
  |},
  +$refType: OffersContainer_lists$ref,
|};
export type OffersContainer_lists$data = OffersContainer_lists;
export type OffersContainer_lists$key = {
  +$data?: OffersContainer_lists$data,
  +$fragmentRefs: OffersContainer_lists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first",
      "type": "Int"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after",
      "type": "String"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startingAfter",
      "type": "DateTime"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endingBefore",
      "type": "DateTime"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "active",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": [
          "offers"
        ]
      }
    ]
  },
  "name": "OffersContainer_lists",
  "selections": [
    {
      "alias": "offers",
      "args": [
        {
          "kind": "Variable",
          "name": "active",
          "variableName": "active"
        },
        {
          "kind": "Variable",
          "name": "endingBefore",
          "variableName": "endingBefore"
        },
        {
          "kind": "Variable",
          "name": "startingAfter",
          "variableName": "startingAfter"
        }
      ],
      "concreteType": "OfferConnection",
      "kind": "LinkedField",
      "name": "__Offers_offers_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OfferEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Offer",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "OfferList_offers"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Lists"
};
// prettier-ignore
(node/*: any*/).hash = '5d280793ee20a11909a1ac1d9f0b8ce7';

module.exports = node;
